module.exports = __webpack_public_path__ + "05_short_yellow.52b7fc9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/05_short_yellow.png
// module id = F6XX
// module chunks = 0